// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__kymBI","wide":"Container_wide__AYDwP","reading":"Container_reading___z2xo"};